var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDisabled = function SvgDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 47.8h1c1.1 0 1.6-.5 1.6-1.5s-.6-1.5-1.7-1.5h-1v3zm.1 6.4h-3.1v-12h4.9c1.3 0 2.3.4 3 1.1s1.1 1.7 1.1 3-.4 2.3-1.1 3-1.7 1.1-3 1.1h-1.8v3.8z",
    fill: "#262a30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 50.2l-3.7 2-7.3-14H31V34h9.8v-2.7H31v-8.1l.3-.1c1.8-.3 3.2-1.9 3.2-3.8 0-2.1-1.7-3.9-3.8-3.9S27 17 27 19.2c0 1.2.5 2.2 1.4 3l.1.1V41h14.1l7.7 14.9 6.1-3.3-1.4-2.4zM26.4 35.5v-3.3c-4.7 2.5-7.7 7.4-7.7 12.9 0 8.1 6.5 14.6 14.5 14.6 5.7 0 10.8-3.4 13.2-8.5L44.7 48c-1.3 5.3-6 9.1-11.5 9.1-6.5 0-11.8-5.3-11.8-11.9 0-3.9 1.7-7.5 5-9.7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262a30"
  })));
};
export default SvgDisabled;